import { Base } from '@studiometa/js-toolkit';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
gsap.registerPlugin(ScrollTrigger);

/**
 * ScreenPhone component
 */
export default class ScreenPhone extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'ScreenPhone',
    refs: ['video', 'content[]', 'inner[]'],
    options: {
      name: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * mounted
   */
  mounted() {
    gsap.to(this.$el, {
      opacity: 1,
      zIndex: 2,
      duration: 1,
      ease: 'power4.inOut',
      scrollTrigger: {
        trigger: `#${this.$options.name}`,
        toggleActions: 'play reverse play reverse',
        end: '+=2500px',
      },
      onComplete: () => {
        this.$refs.video.currentTime = 0;
        this.$refs.video.play();
      },
      onReverseComplete: () => {
        this.$refs.video.pause();
        this.$refs.video.currentTime = 0;
      },
    });
  }

  /**
   * Handle video time updates
   */
  onVideoTimeupdate() {
    const currentTime = this.$refs.video.currentTime;
    this.updateContentActiveState(currentTime);
  }

  /**
   * Handle inner content click
   * @param {{ index: number }} params
   */
  onContentClick({ index }) {
    const interval = 8;
    const targetTime = index * interval;
    this.$refs.video.currentTime = targetTime;
  }

  /**
   * Update content active state based on video time
   * @param {number} currentTime
   */
  updateContentActiveState(currentTime) {
    const interval = 8;
    const activeIndex = Math.floor(currentTime / interval) % this.$refs.content.length;

    this.$refs.content.forEach((content, index) => {
      if (index === activeIndex) {
        this.setContentActive(content);
        this.setInnerActive(this.$refs.inner[index]);
      } else {
        this.setContentInactive(content);
        this.setInnerInactive(this.$refs.inner[index]);
      }
    });
  }

  /**
   * Set content element to active state
   * @param {HTMLElement} content
   */
  setContentActive(content) {
    content.classList.remove('text-white');
    content.classList.add('text-red-chamonix');
  }

  /**
   * Set content element to inactive state
   * @param {HTMLElement} content
   */
  setContentInactive(content) {
    content.classList.remove('text-red-chamonix');
    content.classList.add('text-white');
  }

  /**
   * Set inner element to active state (open)
   * @param {HTMLElement} inner
   */
  setInnerActive(inner) {
    inner.classList.remove('grid-rows-[0fr]');
    inner.classList.add('grid-rows-[1fr]');
  }

  /**
   * Set inner element to inactive state (closed)
   * @param {HTMLElement} inner
   */
  setInnerInactive(inner) {
    inner.classList.remove('grid-rows-[1fr]');
    inner.classList.add('grid-rows-[0fr]');
  }

  /**
   * Reset all content to inactive state
   */
  resetContentStates() {
    this.$refs.content.forEach((content, index) => {
      this.setContentInactive(content);
      this.setInnerInactive(this.$refs.inner[index]);
    });
  }
}
